import { render, staticRenderFns } from "./SampleMemoryVibration.vue?vue&type=template&id=4bf843dd&scoped=true"
import script from "./SampleMemoryVibration.vue?vue&type=script&lang=js"
export * from "./SampleMemoryVibration.vue?vue&type=script&lang=js"
import style0 from "./SampleMemoryVibration.vue?vue&type=style&index=0&id=4bf843dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf843dd",
  null
  
)

export default component.exports